import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_shipping_price_book_hdr_RowClass} from '../../../dbschema';

export class ShippingPriceBookHeaderContainerModel extends BaseContainerModel {
  bl_fi_mst_shipping_price_book_hdr: bl_fi_mst_shipping_price_book_hdr_RowClass = new bl_fi_mst_shipping_price_book_hdr_RowClass();
}
